<app-bloqueio-tela [telaBloqueada]="telaBloqueada"></app-bloqueio-tela>
<app-notificacao></app-notificacao>
<router-outlet></router-outlet>
